// extracted by mini-css-extract-plugin
module.exports = {"cont-tab":"OtherInputTab_cont-tab__JC-pj","btn-tab":"OtherInputTab_btn-tab__1XOXE","bar":"OtherInputTab_bar__21_SS"};